import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Form, Input, Button, message, Checkbox, Col, Row, Card } from "antd";

// Constant
import { ROUTE, ROOT_CONSTANT } from "../../constants";
// import { ROUTES, COMMON_FEATURES } from "../../../v1/constants";

// Components
import { ButtonLink, CopyRightFooter } from "../../components";

/**
 * Redux Actions
 */
import * as ACTIONS from "../../services/redux/actions";

// Style
import styles from "../index.module.css";
import "./index.css";
const { icon_logo_login } = ROOT_CONSTANT.IMG.ICON.LOGIN;
const { bgLogin } = ROOT_CONSTANT.IMG.BG.LOGIN;

const SSOLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loadingLogin, setLoadingLogin] = useState(false);

  const onFinish = (e) => {
    const { email, password } = e;

    dispatch(
      ACTIONS.main_user.auth_user_sign_in(
        email.trim(),
        password,
        ({ status, err }) => {
          if (status === 200) {
            setLoadingLogin(false);
          } else if (status === 404) {
            message.error(err);
            setLoadingLogin(false);
          }
        }
      )
    );

    setLoadingLogin(true);
  };

  return (
    <div className={styles.mainWrap}>
      <Card className={styles.mainCardLogin}>
        <Row>
          <Col span={9}>
            <div className={styles.inputForm}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <img src={icon_logo_login} alt="Logo" className="logoLogin" />
              </div>
              <div className={styles.tagline}>
                <h4 style={{ marginTop: "6%" }}>
                  <strong>Login</strong>
                </h4>
              </div>
              <p className="text-login">
                Empower your business with payroll advances
              </p>

              <Form
                form={form}
                name="form_login"
                layout="vertical"
                onFinish={onFinish}
              >
                <div className="containerForm">
                  <label htmlFor="email" className="labelInputLogin">
                    Email
                  </label>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Email is required",
                        type: "text",
                      },
                    ]}
                    className="material-textfield"
                    hasFeedback
                  >
                    <Input placeholder="" className="inputForm" />
                  </Form.Item>
                </div>
                <div className="containerForm">
                  <label htmlFor="password" className="labelInputLogin">
                    Password
                  </label>
                  <Form.Item
                    name="password"
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: 'Kata Laluan is required'
                    //     },
                    // ]}
                    className="material-textfield"
                    hasFeedback
                  >
                    <Input.Password placeholder="" className="inputForm" />
                  </Form.Item>
                </div>

                <Form.Item>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "18px",
                    }}
                  >
                    <Checkbox style={{ color: "gray", fontSize: "18px" }}>
                      Remember Me
                    </Checkbox>
                    <ButtonLink
                      style={{ color: "#0E2483" }}
                      onClick={() =>
                        navigate(ROUTE.MODULE_ROUTE.FORGOT_PASSWORD)
                      }
                    >
                      Forget Password
                    </ButtonLink>
                  </div>
                </Form.Item>
                <Form.Item>
                  <Button
                    className={styles.inputButton}
                    type="primary"
                    htmlType="submit"
                    loading={loadingLogin}
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>

              <div className={styles.footer}>
                Don't have an account?
                <ButtonLink
                  className={styles["link"]}
                  // onClick={() => navigate(ROUTE.MODULE_ROUTE.Individual_Sign_Up)}
                  style={{
                    cursor: "pointer",
                    marginLeft: "5px",
                    marginBottom: "10.5%",
                  }}
                >
                  Sign Up
                </ButtonLink>{" "}
                now.
              </div>
            </div>
          </Col>
          <Col span={15}>
            <img
              src={bgLogin}
              alt="Background"
              className="background-container"
            />
          </Col>
        </Row>
      </Card>

      <CopyRightFooter />
    </div>
  );
};

export default SSOLogin;
